import React from 'react';
import { Typography, useTheme } from '@mui/material';
import AlertDialog from '../../../../../../../components/AlertDialog';
import { FormSchemaV3 } from '../../../../../../../types/preloan/v3';
import analytics from '../../../../../../../utils/analytics';

type ConfirmationDialogProps<FormSchema> ={
    formSchema: FormSchema,
    isTriggered: boolean,
    handleSubmit: ()=> void | Promise<void>,
}

export default function ConfirmationDialog
<T extends FormSchemaV3>(props:ConfirmationDialogProps<T>) {
  const {
    formSchema,
    isTriggered,
    handleSubmit,
  } = props;
  const theme = useTheme();

  const productName = () => {
    if (formSchema.requestLoanData.periods < 2) {
      return 'avance';
    }
    return 'crédito';
  };

  React.useEffect(() => {
    if (isTriggered) {
      analytics.page('PLR - RESULTADO', 'IR A FIRMAR');
    }
  }, [isTriggered]);

  return (
    <AlertDialog
      dialogTitle={(
        <Typography
          fontWeight="bold"
          variant="h5"
          align="center"
          gutterBottom
          data-pw="preloan-pre-signature-title"
          component="div"
        >
          ¡Atención!

        </Typography>
)}
      dialogContent={(
        <div style={{ textAlign: 'center' }}>
          {formSchema.step === 'LOAN_SIMULATION'
                  && (
                  <Typography variant="body1" style={{ maxWidth: '400px' }}>
                    Al presionar
                    {' '}
                    <b
                      style={{ color: theme.palette.secondary.main }}
                    >
                      CONTINUAR,
                    </b>
                    {' '}

                    revisarás las condiciones

                    y luego deberás configurar un pago automático de cuentas (PAC),
                    por lo que
                    {' '}
                    <b>
                      no hay posibilidad de volver
                    </b>
                    {' '}
                    a la simulación de tu
                    {' '}
                    {productName()}
                    .
                  </Typography>
                  )}
        </div>
            )}
      action={handleSubmit}
      button={<div />}
      isTriggered={isTriggered}
      submitButtonLabel="Continuar"
    />

  );
}
